import React from 'react';
import './AccessRequired.scss';

export default function AccessRequired({ onLogin, onSignup }) {
    return (
        <div className="access-apple">
            <div className="access-apple__card">
                <div className="access-apple__icon">🔒</div>
                <h2 className="access-apple__title">To view this content</h2>
                <p className="access-apple__text">
                    Please{' '}
                    <button onClick={onLogin} className="access-apple__link">
                        Log in
                    </button>{' '}
                    or{' '}
                    <button onClick={onSignup} className="access-apple__link">
                        Create account
                    </button>
                    .
                </p>
            </div>
        </div>
    );
}
